export default __webpack_public_path__ + "static/media/teku-bg.fbf134e0.png";